"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpScreen = void 0;
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const forms_1 = require("@/forms");
const history_1 = __importDefault(require("@/helpers/history"));
const redux_1 = require("@/redux");
const api_payloads_1 = require("@/redux/api-payloads");
const selectors_1 = __importDefault(require("@/selectors"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
class SignUpScreen extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.signup = (data) => {
            const { makeRequest } = this.props;
            makeRequest(data);
        };
        this.onBack = () => {
            history_1.default.push(constants_1.Routes.Login);
        };
    }
    render() {
        return (react_1.default.createElement("div", { className: styles_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_scss_1.default.leftContainer },
                react_1.default.createElement("div", { className: styles_scss_1.default.formContainer },
                    react_1.default.createElement("h4", { className: styles_scss_1.default.title }, constants_1.default.signup.welcomeToClearSummit),
                    react_1.default.createElement("p", { className: styles_scss_1.default.description }, constants_1.default.signup.createAccount),
                    react_1.default.createElement(forms_1.SignUpForm, null),
                    react_1.default.createElement("div", { className: styles_scss_1.default.signUpContainer },
                        react_1.default.createElement("div", { className: styles_scss_1.default.textContainer },
                            react_1.default.createElement("p", null, constants_1.default.signup.alreadyHaveAnAccount),
                            react_1.default.createElement(components_1.Link, { to: constants_1.Routes.Login, className: styles_scss_1.default.signUpButton }, constants_1.default.signup.login))))),
            react_1.default.createElement("div", { className: styles_scss_1.default.rightContainer },
                react_1.default.createElement("img", { src: constants_1.Images.loginBackground, alt: constants_1.Images.loginBackground }))));
    }
}
exports.SignUpScreen = SignUpScreen;
const mapStateToProps = (state) => ({
    user: selectors_1.default.user.getUser(state),
    error: state.user.error,
});
const mapDispatchToProps = {
    makeRequest: (data) => redux_1.ActionCreators.api.makeRequest.dispatch(api_payloads_1.signUpPayload(data)),
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(SignUpScreen);
